import createReactComponent from '../createReactComponent';
export default createReactComponent('outline', 'letter-t', 'IconLetterT', [["path",{"d":"M6 4l12 0","key":"svg-0"}],["path",{"d":"M12 4l0 16","key":"svg-1"}]]);